import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Actively unregister any previously installed service worker so the
// browser stops treating the site as an installable PWA ("Open in app" pill).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => { /* no-op */ });
  if (window.caches?.keys) {
    window.caches.keys()
      .then((keys) => keys.forEach((k) => window.caches.delete(k)))
      .catch(() => { /* no-op */ });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
